




























































































































































































































































































































































































































































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator'
import { BracketTournamentTeamSelected } from '@/plugins/TournamentBracket/types'
import {
  BracketAdjacencyMatrixEntity,
  StageFormatType,
  BracketState
} from '@/api/stage'
import BracketMatchGameChips from '@/modules/tournament/components/BracketMatchGameChips'
import TournamentTeamDialog from '@/modules/tournament/components/TournamentTeamDialog'
import { dateTime } from '@/utils'

@Component({
  components: {
    TournamentTeamDialog,
    BracketMatchGameChips
  },
  filters: {
    dateTime
  }
})
export default class StageBracket extends Vue {
  @Prop({ type: Array, required: true })
  readonly brackets!: BracketAdjacencyMatrixEntity[]

  @Prop({ required: true })
  readonly format!: StageFormatType

  @Prop({ default: false })
  readonly dense!: boolean

  @PropSync('tab', { required: true }) groupTab!: string | null

  selectedTournamentTeamId: string = ''
  isTournamentTeamDialogVisible: boolean = false

  scoreTableExpanded: any = 0

  /* Methods */
  onTeamSelected(data: BracketTournamentTeamSelected) {
    this.selectedTournamentTeamId = data.team.tournamentTeamId
    this.isTournamentTeamDialogVisible = true
  }

  closeTournamentTeamDialog() {
    this.isTournamentTeamDialogVisible = false
    this.selectedTournamentTeamId = ''
  }

  /* Computed Properties */
  get sortedBracket() {
    return this.brackets.sort((a, b) => a.groupNumber - b.groupNumber)
  }

  get disableDragScroll() {
    return this.$vuetify.breakpoint.mobile
  }
}
